/**
 * Chart themes page, /dashboard/overview/themes (screenshots/80; §2.12 "Chart themes"). Themes come from /api/themes
 * (team + yours; built-ins are in the client) and register with ECharts on load and save (themeStore).
 * "Where it's used" comes from the same response (`usage`: per theme, the overviews and chart counts).
 */
import { useEffect, useState } from "react";
import { ThemeBuilder } from "./charts/ThemeBuilder";
import type { ChartTheme } from "./charts/themes";
import { themeStore } from "./chartEditorStore";

type Usage = Record<string, { overview: string; charts: number }[]>;

export function ThemesPage({ canTeam }: { canTeam: boolean }) {
  const [usage, setUsage] = useState<Usage>({});
  useEffect(() => {
    fetch("/api/themes", { credentials: "include" }).then((r) => (r.ok ? r.json() : null))
      .then((d: { saved: ChartTheme[]; teamDefault: string; usage?: Usage } | null) => {
        if (!d) return;
        themeStore.getState().load(d.saved ?? [], d.teamDefault);
        const sel = d.saved?.find((t) => t.id === d.teamDefault) ?? d.saved?.[0];
        if (sel) themeStore.getState().select(sel.id);
        setUsage(d.usage ?? {});
      }).catch(() => {});
  }, []);
  return <ThemeBuilder store={themeStore} usage={usage} canTeam={canTeam} />;
}
